import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AmbienteHeaderService } from '../../@theme/services/ambiente-header.service';

@Injectable()
export class AmbienteInterceptor implements HttpInterceptor {
  constructor(private ambienteHeaderService: AmbienteHeaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const ambiente = event.headers.get('X-Ambiente');
          if (ambiente) {
            this.ambienteHeaderService.aplicar(ambiente);
          }
        }
      })
    );
  }
}
